import React from "react";
import { usePatientAuthFlags } from "../../Hooks/usePatientAuthFlags";
import "./Footer.css";

function Footer() {
  const { isRadicalAuth } = usePatientAuthFlags();

  return (
    <div
      className={`footer-container ${isRadicalAuth ? "footer-container--radical" : ""}`}
    >
      <div className="footer-heading font-Manrope">
        <span className="footer-text">
          Version 1.0.2 | Copyright Reserved By MEDILIS SYSTEMS LTD © 2026
        </span>
      </div>
    </div>
  );
}

export default Footer;
